/* eslint-disable @typescript-eslint/no-require-imports */

export const IllusUpsellCtaBg = require('./Illus-UpsellCtaBg.png');
